import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../utils/supabase/client';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { toast } from 'sonner';
import { useTranslation } from '../../utils/useTranslation';

export function AuthCallback() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the hash parameters from the URL
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const accessToken = hashParams.get('access_token');
        const refreshToken = hashParams.get('refresh_token');
        const error = hashParams.get('error');
        const errorDescription = hashParams.get('error_description');

        if (error) {
          toast.error(errorDescription || t('auth.callback.errors.auth'));
          navigate('/login');
          return;
        }

        if (accessToken && refreshToken) {
          // Exchange the code for a session
          const { error: sessionError } = await supabase.auth.getSession();
          
          if (sessionError) {
            throw sessionError;
          }

          toast.success(t('auth.loginSuccess'));
          navigate('/');
        } else {
          // Handle PKCE flow
          const { error: exchangeError } = await supabase.auth.getSession();
          
          if (exchangeError) {
            throw exchangeError;
          }

          toast.success(t('auth.loginSuccess'));
          navigate('/');
        }
      } catch (error: unknown) {
        console.error('Auth callback error:', error);
        const errorMessage = error instanceof Error ? error.message : t('auth.callback.errors.exchange');
        toast.error(errorMessage);
        navigate('/login');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 via-white to-green-50">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle>{t('auth.callback.processing')}</CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-red-500 border-t-transparent mx-auto mb-4" />
          <p className="text-gray-600">{t('auth.callback.description')}</p>
        </CardContent>
      </Card>
    </div>
  );
}